export interface EmulatorTimeInfo {
	real: number
	timeFactor: number
	timeFactorUsed: boolean
	now: number
}

const windowAny = window as any;

const EmulatorTimeCurrent = {
	info: null as EmulatorTimeInfo | null,
	nowDate(): Date {
		if (!this.info) return new Date();

		let passed = new Date().getTime() - this.info.real
		if (this.info.timeFactorUsed) {
			passed *= this.info.timeFactor
		}
		return new Date(this.info.now + passed);
	}
};

export function getCurrentTime(): number {
	return getCurrentDate().getTime();
}

export function getCurrentDate(): Date {
	if (windowAny.EmulatorTimeCurrent) {
		return windowAny.EmulatorTimeCurrent.nowDate();
	}
	return new Date();
}

export function getEmulatorTime(): typeof EmulatorTimeCurrent {
	if (!windowAny.EmulatorTimeCurrent) {
		windowAny.EmulatorTimeCurrent = EmulatorTimeCurrent;
	}
	return windowAny.EmulatorTimeCurrent;
}

export function setEmulatorTime(info: EmulatorTimeInfo | null) {
	// console.log([info, info ? new Date(info.real) : null, info ? new Date(info.now) : null]);
	getEmulatorTime().info = info;
}
